<template>
  <div >
    <el-button
      class="btn btn1"
      style="margin-left: 0px"
      icon="el-icon-circle-plus-outline"
      
      @click="addDataEvent"
      >{{ $t("message.button.add") }}</el-button
    >
    <!-- :disabled="this.listUsed==1" -->
    <el-button
      class="btn btn2"
      icon="el-icon-sort"
      
      @click="sortTablePage"
      >{{ $t("message.button.order") }}
    </el-button>
    <!-- <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox">{{
      $t("message.button.delete")
    }}</el-button> -->
    <el-button
      class="btn btn3"
      icon="el-icon-document-checked"
      @click="getUpdateEvent"
      >{{ $t("message.button.save") }}</el-button
    >
    <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave">
      {{$t("message.button.cancel")}}
    </el-button>

    <div style="padding: 10px 0">
      <vxe-grid
        ref="xGrid"
        auto-resize
        v-bind="gridOptions"
        @edit-disabled="editDisabledEvent"
        @cell-dblclick="dblclick"
      >
        <!-- <template v-slot:operate="{ row }">
          <el-button :title="$t('message.button.delete')"  @click="removeRowEvent(row)" type="text" icon="el-icon-delete" >{{$t('message.button.delete')}}</el-button>
        </template> -->
      </vxe-grid>
    </div>
    <el-dialog :title="$t('message.table.listOrder')" :visible.sync="dialogSortTable">
        <div class="sortLists">
          <div
            class="sortList"
            style="border: none; color: #606266; font-weight: bold; background: #ebebeb"
          >
            <span style="margin-left: 10px; display: inline-block; width: 10%">{{
              $t("message.table.SN")
            }}</span>
            <span style="margin-left: 10px; display: inline-block; width: 30%">{{
              $t("message.table.code")
            }}</span>
            <span style="margin-left: 10px; display: inline-block; width: 30%">{{
              $t("message.table.name")
            }}</span>
            <span style="margin-right: 10px; float: right">{{
              $t("message.table.des")
            }}</span>
          </div>
        </div>
        <div class="sortLists" ref="example">
          <div class="sortList" v-for="(item, index) in sort_table_val" :key="index">
            <span style="margin-left: 10px; display: inline-block; width: 10%">{{ item.entryOrder }}</span>
            <span style="margin-left: 10px; display: inline-block; width: 30%">{{
              item.entryCode
            }}</span>
            <span style="margin-left: 10px; display: inline-block; width: 30%">{{ item.entryValue }}</span>
            <span style="margin-right: 10px; float: right">{{ item.description }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="updateSortClose">{{
            $t("message.button.cancel")
          }}</el-button>
          <el-button type="primary" @click="updateSort">{{
            $t("message.button.affirm")
          }}</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Sortable from "sortablejs";
export default {
  data() {
    return {
      dialogSortTable: false,
      sort_table_val: [],
      sort_table_val_old: [],
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "510",
        size: "small",
        columns: [
          {
            type: "checkbox",
            width: 50,
            fixed: null,
          },
          {
            field: "entryOrder",
            title: this.$t("message.table.SN"),
            // editRender: {
            //   name: "$input",
            // },
          },
          {
            field: "entryCode",
            title: this.$t("message.table.code"),
            editRender: {
              name: "$input",
            },
          },
          {
            field: "entryValue",
            title: this.$t("message.table.name"),
            editRender: {
              name: "$input",
              props: {
                placeholder: this.$t("message.placeholder.input"),
              },
            },
          },
          {
            field: "description",
            title: this.$t("message.table.des"),
            editRender: {
              name: "$input",
            },
          },
          {
            field: "enabled",
            title: this.$t("message.table.status"),
            editRender: {
              name: "$select",
              options: [
                {
                  label: this.$t("message.table.enabled"),
                  value: 1,
                },
                {
                  label: this.$t("message.table.disabled"),
                  value: 0,
                },
              ],
            },
          },
          // {
          //   title: this.$t('message.table.actions'),
          //   width: 120,
          //   slots: {
          //       default: 'operate'
          //   }
          // }
        ],
        data: [],
        
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        editRules: {
          entryValue: [
            {
              required: true,
              message: this.$t("message.warning.required"),
            },
            {
              min: 1,
              max: 200,
              message: this.$t("message.warning.length_103"),
            },
          ],
          entryCode: [
            {
              required: true,
              message: this.$t("message.warning.required"),
            },
            {
              min: 1,
              max: 200,
              message: this.$t("message.warning.length_103"),
            },
          ],
          description: [
            {
              required: true,
              message: this.$t("message.warning.required"),
            },
            {
              min: 1,
              max: 200,
              message: this.$t("message.warning.length_103"),
            },
          ],
        },
        sortConfig: {
          trigger: "cell",
        },
      },
    };
  },
  props: ["listUsed"],
  methods: {
    removeRowEvent(row) {
      console.log(row);
      console.log(this.listUsed);
      // if(this.listUsed==1){
      //   this.$message({
      //     type: "error",
      //     message: this.$t("message.error.cantDelete"),
      //   });
      //   return false;
      // }
      this.$confirm(this.$t('message.confirm.deleteList'), this.$t('message.tips.tip'), {
        confirmButtonText: this.$t('message.button.affirm'),
        cancelButtonText: this.$t('message.button.cancel'),
        type: 'warning'
      }).then(() => {
        var vm = this;
        var deleteListEntry = { //post更改的值
          entryId: row.entryId,
          listId: row.listId
        };
        console.log(deleteListEntry);
        axios.post("/pmdm/admin/list/deleteListEntry",deleteListEntry)
          .then(function (res) {
            if (res.data.code == 200) {
              console.log(res);
              vm.$message({
                type: 'success',
                message: res.data.message
              });
              vm.getListInfo();
            };
          })
          .catch(function (error) {
            //console.log(error);
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('message.tips.deleteCancel')
        });
      });
    },
    sortTablePage() {
      var vm = this;
      this.sort_table_val = this.deepClone(this.sort_table_val_old);//fix 524 
      this.dialogSortTable = true;
      this.$nextTick(() => {
        vm.srotTable();
      });
    },
    srotTable() {
      var vm = this;
      var el = this.$refs["example"];
      console.log(el);
      console.log(this.sort_table_val);
      //设置配置
      var ops = {
        animation: 150,
        ghostClass: "blue-background-class",
        // },
        onEnd: function (evt) {
          //拖拽结束发生该事件
          vm.sort_table_val.splice(
            evt.newIndex,
            0,
            vm.sort_table_val.splice(evt.oldIndex, 1)[0]
          );
          var newArray = vm.sort_table_val.slice(0);
          vm.sort_table_val = [];
          vm.$nextTick(function () {
            vm.sort_table_val = newArray;
          });
        },
      };
      //初始化
      var sortable = Sortable.create(el, ops);
    },
    updateSortClose() {
      this.dialogSortTable = false;
      this.sort_table_val = this.deepClone(this.sort_table_val_old);
      var vm = this;
      var el = this.$refs["example"];
      var sortTable = Sortable.create(el);
      sortTable.destroy(); //销毁排序
    },
    updateSort() {
      console.log(this.sort_table_val);
      var vm = this;
      var data = {
        updateEntry: this.sort_table_val,
      };
      // for (var i = 0; i < this.sort_table_val.length; i++) {
      //   var obj = {};
      //   obj.id = this.sort_table_val[i].id;
      //   var name = this.sort_table_val[i].statusType;
      //   obj.statusType = this.type_name_arr.indexOf(name);
      //   data.updateEntry.push(obj);
      // }
      axios
        .post("/pmdm/admin/list/updateEntryOrder", data)
        .then(function (res) {
          if (res.data.code == 200) {
            console.log(res);
            vm.$message({
              type: "success",
              message: res.data.message,
            });
            vm.dialogSortTable = false;
            vm.getListInfo();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    addDataEvent() {
      console.log(this.listUsed);
      this.$refs.xGrid
        .insert({
          entryValue: "",
          description: "",
          enabled: 1,
          listId: this.$store.state.listId,
        })
        .then((res) => {
          this.$refs.xGrid.setActiveRow(res.row);
        });
    },
    
    getUpdateEvent() {
      console.log(this.listUsed);
      this.$refs.xGrid.validate(true).then((res) => {
        if (!res) {
          let iList = this.$refs.xGrid.getInsertRecords().map(i=>i.entryValue); //获取修改的行
          // console.log(insertList);
          let arr = this.$refs.xGrid.data.map(i => i.entryValue)
          arr = arr.concat(iList);
          if (this.isRepeat(arr)) {
            this.$message.error(this.$t('message.error.nameRepeat'))
            return
          }
          let updateRecords = this.$refs.xGrid.getUpdateRecords();
          console.log(this.$refs.xGrid.getUpdateRecords());
          if (updateRecords.length !== 0) {
            //编辑
            for (var i = 0; i < updateRecords.length; i++) {
              delete updateRecords[i].id;
            }
            var update = {
              updateEntry: updateRecords,
            };
            console.log(update);
            axios
              .post("/pmdm/admin/list/updateEntry", update)
              .then(res => {
                if (res.data.code == 200) {
                  //console.log(res);
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.getListInfo()
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }

          var insertList = this.$refs.xGrid.getInsertRecords();
          if (insertList.length !== 0) {
            for (var i = 0; i < insertList.length; i++) {
              delete insertList[i].children;
              delete insertList[i].id;
            }
            var insert = {
              insertEntry: insertList,
            };
            axios
              .post("/pmdm/admin/list/saveEntry", insert)
              .then((res) => {
                if (res.data.code == 200) {
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                  this.getListInfo();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }
      });
      // //console.log(errMap);
    },
    removeCheckbox() {},
    editDisabledEvent() {},
    dblclick({ row }) {
      // if(this.listUsed==1){
      //   this.$message({
      //     type: "error",
      //     message: this.$t("message.error.cantModify"),
      //   });
      // }
      
      console.log(this.listUsed);
      return false;
    },
    getListInfo(){
      axios.get('/pmdm/admin/list/getListEntries?listId=' + this.$store.state.listId)
				.then( (res) => {
					console.log(res);
					if (res.data.code == 200) {
						this.gridOptions.data = res.data.object.listEntries;
            this.sort_table_val = this.deepClone(res.data.object.listEntries);
            this.sort_table_val_old = this.deepClone(this.sort_table_val);
					}
				})
    },
  },
  created(){
    this.getListInfo()
    console.log(this.listUsed);
  }
};
</script>

<style scoped>

.sortLists {
  width: 100%;
  border-top: 1px solid #ebebeb;
  border-right: 1px solid #ebebeb;
  border-left: 1px solid #ebebeb;
}
.sortList {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #ebebeb;
  line-height: 40px;
}
.btn {
  display: inline-block;
  padding: 4px;
  padding-right: 10px;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}
.btn span {
  position: relative;
  padding: 0 2px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn1 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
  margin-left: 20px;
}

.btn1:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn2 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn2:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 57px;
}

.content-title li {
  float: left;
  padding: 18px 12px 12px 12px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.btn7 {
  height: 32px;
  color: #4b92ff;
  border-color: rgba(75, 146, 255, 0.5);
  background: rgba(75, 146, 255, 0.2);
}

.btn7:hover {
  color: #fff;
  background: rgba(75, 146, 255, 0.4);
}

.btn8 {
  height: 32px;
  color: #fe6263;
  border-color: rgba(254, 98, 99, 0.5);
  background: rgba(254, 98, 99, 0.2);
}

.btn8:hover {
  color: #fff;
  background: rgba(254, 98, 99, 0.4);
}
</style>

